import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Hero from './../../components/Hero';
import Card from './../../components/Card';
import Loader from './../../components/Loader';
import Label from './../../components/Label';
import { Columns, Column, Container, Section } from './../../styles';

import * as charactersActions from './../../actions/charactersActions';

class Home extends Component {
  componentDidMount() {
    const { nextUrl } = this.props;
    this.props.getCharacters(nextUrl);

    window.addEventListener('scroll', this.handleOnScroll);
  }

  componentWillMount() {
    window.removeEventListener('scroll', this.handleOnScroll);
  }

  handleOnScroll = () => {
    const { isLoading, hasMore, error, nextUrl } = this.props;

    if (error || isLoading || !hasMore) return;

    if ( window.innerHeight + document.documentElement.scrollTop === document.documentElement.offsetHeight) {
      this.props.getCharacters(nextUrl);
    }
  }

  render() {
    const { characters, isLoading, hasMore } = this.props;

    return (
      <div>
        <Hero
          title="Rick and Morty"
          subtitle="Focus on science!"
        />
        <Section>
          <Container>
            <Columns>
              { characters.map(item => 
                <Column key={ item.id }>
                  <Card 
                    key={ item.id }
                    id={ item.id }
                    title={ item.name }
                    img={ item.image }
                  />
                </Column>
              ) }
            </Columns>
            { (isLoading) && <Loader /> }
            { (!hasMore) && <Label text="All characters are loaded." /> }
          </Container>
        </Section>
      </div>
    );
  }
};

const mapStateToProps = state => {
  return {
    characters: state.charactersReducer.characters,
    nextUrl: state.charactersReducer.nextUrl,
    isLoading: state.charactersReducer.isLoading,
    hasMore: state.charactersReducer.hasMore,
    error: state.charactersReducer.error,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(charactersActions, dispatch);

export default connect(
  mapStateToProps, 
  mapDispatchToProps
)(Home);